import Vue from 'vue'
import Vuetify from 'vuetify/lib'
import zhHans from 'vuetify/src/locale/zh-Hans'
import zhHant from 'vuetify/src/locale/zh-Hant'
import en from 'vuetify/src/locale/en'
import 'vuetify/src/stylus/app.styl'
import '../theme/default.styl'

Vue.use(Vuetify, {
    theme: {
        //primary: '#ee44aa',
        //secondary: '#424242',
        //accent: '#82B1FF',
        //error: '#FF5252',
        //info: '#2196F3',
        //success: '#4CAF50',
        //warning: '#FFC107'
        primary: '#FF8A80',
        secondary: '#00bcd4',
        accent: '#82b1ff',
        error: '#f44336',
        warning: '#ff9800',
        info: '#FFCDD2',
        success: '#4caf50'
    },
    customProperties: true,
    iconfont: 'fa4',
    lang: {
        locales: {zhHans, en, zhHant},
        current: 'zhHans'
    },
})
